var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h2',[_c('span',{staticClass:"align-middle ml-50"},[_vm._v("Cerrando sesión...")])])])}]

export { render, staticRenderFns }